import { isSharedBrandSession } from "./loginAccount";

export const hasValidToken = (token) => {
  if (!token) {
    return false;
  }

  if (typeof token === "string") {
    return token.trim().length > 0;
  }

  if (typeof token === "object") {
    if (typeof token.token === "string") {
      return token.token.trim().length > 0;
    }

    if (typeof token.accessToken === "string") {
      return token.accessToken.trim().length > 0;
    }

    return Object.keys(token).length > 0;
  }

  return false;
};

export const getStoredUserId = (user) => {
  return user?.userId || user?.id || "";
};

export const readStoredToken = () => {
  const raw = localStorage.getItem("token");
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    return raw;
  }
};

export const isLoggedInUserInfo = (userInformation) => {
  return Boolean(
    userInformation?.isLoggedIn === true && getStoredUserId(userInformation),
  );
};

export const isAuthenticatedUser = (user, token) => {
  return Boolean(getStoredUserId(user) && hasValidToken(token));
};

export const getAccessToken = () => {
  const token = readStoredToken();
  if (typeof token === "string") {
    return token.trim();
  }
  if (typeof token?.accessToken === "string") {
    return token.accessToken.trim();
  }
  if (typeof token?.token === "string") {
    return token.token.trim();
  }
  return "";
};

export const authHeaders = () => {
  const token = getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const normalizeUserType = (userInformation) =>
  String(userInformation?.userType || "").trim().toLowerCase();

export const isVendorAdminUser = (userInformation) => {
  return Boolean(
    isLoggedInUserInfo(userInformation) &&
    normalizeUserType(userInformation) === "vendoradmin",
  );
};

export const isVendorUser = (userInformation) => {
  const userType = normalizeUserType(userInformation);
  return Boolean(
    isLoggedInUserInfo(userInformation) &&
    (userType === "vendor" || userType === "vendoradmin"),
  );
};

export const canAccessRegister = (userInformation) => {
  return (
    isVendorAdminUser(userInformation) || isSharedBrandSession(userInformation)
  );
};
